// おすすめ案件誘導モーダルのタイトル・本文・CTAを回答済版へ差し替える。
// 各要素の data-answered 属性（partialが両版を提供）を読むだけで、文言はJS側に持たない。
// 希望条件の初回保存時はモーダルが未回答版で描画済みのため、保存＝カルテ回答完了に合わせて補正する。
export const applyAnsweredGuidanceModalContent = (): void => {
  const title = document.getElementById('job-offer-guidance-modal-title')
  if (title?.dataset.answered) {
    const lines = JSON.parse(title.dataset.answered) as string[]
    title.replaceChildren(...lines.map(line => {
      const span = document.createElement('span')
      span.textContent = line
      return span
    }))
  }

  const text = document.querySelector<HTMLElement>('.job-offer-guidance-modal-text')
  if (text?.dataset.answered) {
    const lines = JSON.parse(text.dataset.answered) as string[]
    const nodes = lines.flatMap((line, index) =>
      index === 0 ? [document.createTextNode(line)] : [document.createElement('br'), document.createTextNode(line)]
    )
    text.replaceChildren(...nodes)
  }

  const cta = document.querySelector<HTMLAnchorElement>('.job-offer-guidance-modal-cta')
  if (cta?.dataset.answeredLabel && cta.dataset.answeredPath) {
    cta.textContent = cta.dataset.answeredLabel
    cta.setAttribute('href', cta.dataset.answeredPath)
  }
}
